import gql from 'graphql-tag'

export const fetchProductQuery = gql(`
  query ($sku: String) {
    products(filter: { sku: { eq: $sku } }, pageSize: 25, currentPage: 1, sort: { catalog_product_name: ASC }) {
      items {
        multi_deposit
        package_type
        material_type
        product_reco_tags {
          value
          label
          color
        }
        posm_multiplier_flag
        posm_multiplier_value
        number_of_items_in_box
        deliveryDate
        special_price
        volume_fe
        posm_base_price {
          base_price
          base_price_with_tax
        }
        sku
        number_of_products_on_layer
        description {
          html
        }
        stock_status
        ean
        ean_ea
        isavailable_truck_package_ordering
        your_price
        your_price_tax
        favourites
        promo
        weight
        gross_weight_for_one_cas
        other_info_gross_weight
        sap_sub_brand_code
        pallet_weight
        packaging
        options_container
        beer_type
        number_of_layers_per_pallet
        number_of_items_on_pallet
        number_of_products_on_layer
        product_name_sap
        sku_product_detail_page
        brand
        other_info_alcohol
        hectolitres_for_one_cas_frontend
        hectolitres_per_pallet
        other_info_shelf_life
        pack_format
        pack_material
        sap_pack
        sap_pack_configuration
        returnable_package
        sub_brand
        volume
        country_of_origin
        catalog_product_name
        name
        filter_packaging
        product_last
        product_new
        product_sale
        product_recommended
        product_special
        canonical_url
        url_path
        url_key
        url_rewrites {
          url
          parameters {
            name
            value
          }
        }
        price_range {
          minimum_price {
            regular_price {
              value
              currency
            }
          }
        }
        swatch_image
        small_image {
          url
        }
        thumbnail {
          url
        }
        image {
          url
        }
        media_gallery {
          url
        }
        related_products {
          uid
          name
          sku
          price_range {
            minimum_price {
              final_price {
                value
                currency
              }
            }
            maximum_price {
              final_price {
                value
                currency
              }
            }
          }
          swatch_image
          small_image {
            url
          }
          thumbnail {
            url
          }
          image {
            url
          }
          media_gallery {
            url
          }
        }
        promo_price_leaflet {
          promo_price
          promo_price_percentage_with_tax
          promo_price_percentage_wo_tax
          promo_price_is_inside_delivery
          promo_price_valid_from
          promo_price_valid_to
          long_term_discount
          long_term_discount_percentage_with_tax
          long_term_discount_percentage_wo_tax
          base_price
          percentage
        }
        ... on BundleProduct {
          deal_condition
          your_price_sum
          your_price_sum_tax
          bundle_price_sum
          bundle_price_sum_tax
          flexible_package_rules {
            min_units_required
            validity_from
            validity_to
            max_number_of_packages
            max_number_of_items_in_package
            items {
            sku
            is_mandatory
            deal_condition
            min_number_orderable
            max_number_orderable
            validity_from
            validity_to
            }
          }
          bundle_price_details
          bundle_fields {
            minimum_amt
            valid_from
            valid_to
            limited_amount
          }
          bundle_product_details {
            sku
            catalog_product_name
            bundle_quantity
            price_per_unit_w_vat
            price_per_unit_wo_vat
            price_per_unit_wo_vat_discounted
            price_per_unit_w_vat_discounted
            long_term_discount
            short_term_discount
            total_discount_including_deco
            total_discount_excluding_deco
            price_per_unit_w_vat_without_long_term
            price_per_unit_wo_vat_without_long_term
          }
          items {
            option_id
            title
            sku
            type
            required
            position
            your_price_sum
            your_price_sum_tax
            bundle_price
            options {
              uid
              id
              label
              quantity
              can_change_quantity
              price
              price_type
              is_default
              position
              product {
                id
                name
                image {
                 url
                }
                sku
                sku_product_detail_page
                price_range {
                  minimum_price {
                    regular_price {
                      value
                      currency
                    }
                  }
                }
                your_price
                your_price_tax
              }
            }
          }
        }
      }
      page_info {
        page_size
      }
    }
  }
`)
